import React, { useMemo } from 'react';
import { IndicationLimitationCodeSelectOption } from './IndicationLimitationCodeSelect';
// @ts-ignore
import styles from './IndicationLimitationCodeSelectItem.module.scss';
import { joinClasses } from '../../../../Utils/className.util';
import InfoTooltip from '../../../../Components/Popup/InfoTooltip';

interface Props {
	item: IndicationLimitationCodeSelectOption;
	onClick: () => void;
	isSelected: boolean;
}

const IndicationLimitationCodeSelectItem: React.FC<Props> = ({
	item,
	onClick,
	isSelected,
}) => {
	const description: { full: string; shorten: string } | undefined =
		useMemo(() => {
			if (item.description) {
				return {
					full: item.description,
					shorten:
						item.description.length > 150
							? item.description.substring(0, 150) + '...'
							: item.description,
				};
			}
			return undefined;
		}, [item]);

	return (
		<div
			className={joinClasses([styles.item, isSelected ? styles.selected : ''])}
			onClick={onClick}>
			<div className={styles.label}>{item.label}</div>
			{description && (
				<div className={styles.descriptionWrapper}>
					<div>{description.shorten}</div>
					{description.shorten !== description.full && (
						<InfoTooltip>{description.full}</InfoTooltip>
					)}
				</div>
			)}
		</div>
	);
};

export default IndicationLimitationCodeSelectItem;
